import { render, staticRenderFns } from "./ProcedureReportCarrierList.vue?vue&type=template&id=62d1d5af&scoped=true&"
import script from "./ProcedureReportCarrierList.vue?vue&type=script&lang=js&"
export * from "./ProcedureReportCarrierList.vue?vue&type=script&lang=js&"
import style0 from "./ProcedureReportCarrierList.vue?vue&type=style&index=0&id=62d1d5af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d1d5af",
  null
  
)

export default component.exports